module.exports = "/images/ls.svg?4d7b14ba4453874f1f3626f734da3311";